export interface TestResultsUploadInfo {
  success: boolean;
  errorMessage?: string;
  errors: string[];
}
